var App = App || {};

App.Testimonials = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");

        if (!carousel.length)
            return false;

        Carousel(carousel);
    }

    function Carousel(carousel) {
        var slideCount = carousel.find(".widget-testimonial").length;

        if (slideCount >= 3) {
            var splide = new Splide(carousel[0], {
                type: "loop",
                focus: "1",
                pagination: false,
                perPage: 3,
                arrows: true,
                mediaQuery: "min",
                fixedWidth: "50%",
                center:true,
                breakpoints: {
                    768: {
                        focus: "center",
                        perPage: 1,
                        fixedWidth: "33%",
                    },
                }
            });

            splide.on('mounted', function () {
                $(window).on("resize", function () { });
            });

            splide.on('move', function (newIndex, prevIndex) {
                const slideNew = $(splide.Components.Slides.getAt(newIndex).slide);
                const slideOld = $(splide.Components.Slides.getAt(prevIndex).slide);

                slideNew.addClass("is-active");
                slideOld.removeClass("is-active");
            });

            splide.mount({});
        }
        else {
            var splide = new Splide(carousel[0], {
                destroy: true,
            });

        }

    }

    return {
        Init: Init
    };

})(jQuery);